<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="form-wrap form-wrap--wide">
      <Breadcrumbs
        :items="[
          {
            text: 'All Members',
            disabled: false,
            href: '/admin/customers/all'
          },
          {
            text: !!$route.query.id ? 'Edit Member' : 'Add Member',
            disabled: true,
            href: !!$route.query.id
              ? '/admin/customers/add'
              : '/admin/customers/all'
          }
        ]"
      />
      <div class="page-head mt-2">
        <h1 class="page-head__title">
          {{ !!$route.query.id ? "Edit Member Details" : "New Member" }}
        </h1>
        <p class="page-head__sub">
          {{
            !!$route.query.id
              ? "Update this member's details."
              : "Register a new member."
          }}
        </p>
      </div>

      <div class="form-card">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(addNewMember)">
            <div class="d-flex flex-row flex-grow-1 justify-space-between">
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Last Name"
                  outlined
                  v-model="member.firstName"
                  hint="Enter members' last name "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="First Name"
                  outlined
                  v-model="member.lastName"
                  hint="Enter members' last name "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
            </div>
            <div class="d-flex flex-row flex-grow-1 justify-space-between">
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Email Address"
                  outlined
                  v-model="member.emailAddress"
                  hint="Enter members' email address "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required|numeric|min:10|max:13"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Phone number"
                  outlined
                  v-model="member.phoneNumber"
                  hint="Enter members' phone number "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
            </div>
            <div class="d-flex flex-row flex-grow-1 justify-space-between">
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required"
                v-slot="{ errors }"
              >
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="member.dateOfBirth"
                      label="Date Of Birth"
                      readonly
                      class="ma-1"
                      outlined
                      :error-messages="errors[0]"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="member.dateOfBirth"
                    :active-picker.sync="activePicker"
                    color="primary"
                    min="1950-01-01"
                    max="2010-12-31"
                    @change="save"
                  ></v-date-picker>
                </v-menu>
              </ValidationProvider>
              <ValidationProvider
                class="flex flex-row flex-grow-1 ma-1"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  label="Marital Status"
                  outlined
                  :items="[
                    { name: 'Married', value: 'M' },
                    { name: 'No Married', value: 'N' }
                  ]"
                  item-value="value"
                  v-model="member.maritalStatus"
                  item-text="name"
                  :error-messages="errors[0]"
                >
                </v-autocomplete>
              </ValidationProvider>
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Account Number"
                  outlined
                  v-model="member.accountNumber"
                  hint="Enter members' Account Number "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
            </div>
            <div class="d-flex flex-row">
              <v-autocomplete
                label="Is Micro Account ?"
                outlined
                class="ma-1 micro-select"
                :items="[
                  { name: 'Yes', value: true },
                  { name: 'No', value: false }
                ]"
                item-value="value"
                v-model="member.isMicroAccount"
                item-text="name"
              >
              </v-autocomplete>
            </div>
            <div class="form-actions">
              <v-btn
                :disabled="isLoading"
                :loading="isLoading"
                color="primary"
                depressed
                type="submit"
                class="text-none save-btn"
              >
                Save
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>

      <div v-if="$route.query.id" class="form-card mt-5">
        <h2 class="section-title">Update Customer PIN</h2>
        <p class="page-head__sub mb-4">
          Set the member's PIN here — PIN must be exactly 4 digits.
        </p>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(setPIN)">
            <div class="d-flex flex-row flex-grow-1 align-start">
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                v-slot="{ errors }"
                rules="required|numeric|min:4|max:4"
              >
                <v-text-field
                  label="New PIN"
                  outlined
                  :type="show ? 'text' : 'password'"
                  v-model="pin.newPin"
                  hint="Enter members' new PIN "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
              <ValidationProvider
                class="flex flex-row flex-grow-1"
                rules="required|numeric|min:4|max:4"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Confirm PIN"
                  outlined
                  :type="show ? 'text' : 'password'"
                  v-model="pin.confirmPin"
                  hint="Confirm members' new PIN "
                  class="ma-1"
                  :error-messages="errors[0]"
                />
              </ValidationProvider>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="show = !show"
                    class="mt-4 ml-1"
                    color="primary"
                  >
                    <v-icon>{{
                      show ? "mdi-eye-off-outline" : "mdi-eye-outline"
                    }}</v-icon>
                  </v-btn>
                </template>
                <span>Show PIN</span>
              </v-tooltip>
            </div>

            <div class="form-actions">
              <v-btn
                :disabled="isLoading"
                :loading="isLoading"
                color="primary"
                depressed
                type="submit"
                class="text-none save-btn"
              >
                Save
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric, required, email, min, max } from "vee-validate/dist/rules";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
extend("required", {
  ...required,
  message: `Field is required`
});
extend("numeric", {
  ...numeric,
  message: `Field only accept only numeric characters`
});
extend("min", {
  ...min,
  message: "Invalid input provided"
});
extend("max", {
  ...max,
  message: "Invalid input provided"
});
extend("email", {
  ...email,
  message: `Invalid email address provided`
});
import moment from "moment";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    SnackBar: loadComponent(`component/SnackBar`),
    Breadcrumbs: loadComponent(`component/Breadcrumbs`)
  },
  computed: {
    ...mapGetters({
      isLoading: "getIsLoading",
      details: "members/getMemberDetails"
    })
  },
  mixins: [SnackBarMixins],
  data() {
    return {
      menu: false,
      date: null,
      activePicker: null,
      pin: {
        newPin: "",
        confirmPin: ""
      },
      show: false,
      member: {
        accountNumber: "",
        firstName: "",
        lastName: "",
        emailAddress: "",
        maritalStatus: "",
        dateOfBirth: null,
        phoneNumber: "",
        isMicroAccount: false
      }
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    details(payload) {
      const {
        firstName,
        lastName,
        phoneNo,
        emailAddress,
        maritalStatus,
        birthDate,
        code,
        isMicroAccount
      } = payload;

      this.member = {
        firstName,
        lastName,
        phoneNumber: phoneNo,
        emailAddress,
        maritalStatus,
        accountNumber: code?.toString(),
        dateOfBirth: moment(birthDate ?? Date.now()).format("YYYY-MM-DD"),
        isMicroAccount
      };
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    setPIN() {
      this.$store.dispatch("members/setPIN", {
        ...this.pin,
        memberId: this.$route.query?.id
      });
    },
    addNewMember() {
      if (this.$route.query.id) {
        this.$store.dispatch("members/update", {
          _id: this.$route.query.id,
          ...this.member
        });
        return;
      }
      this.$store.dispatch("members/create", {
        ...this.member
      });
    }
  },
  created() {
    if (this.$route.query.id) {
      this.$store.dispatch("members/details", this.$route.query.id);
    }
  }
};
</script>

<style scoped>
.form-wrap--wide {
  max-width: 760px;
}
.micro-select {
  max-width: 240px;
}
.save-btn {
  border-radius: var(--radius) !important;
  height: 42px !important;
  min-width: 120px;
  font-weight: 600;
}
</style>
